/* SickHaus product page V8 (theme v4.0) */
(function () {
  'use strict';
  function qa(r, s) { return Array.prototype.slice.call(r.querySelectorAll(s)); }
  function q(r, s) { return r.querySelector(s); }
  function money(cents, fmt) {
    cents = Number(cents || 0);
    if (window.Shopify && Shopify.formatMoney) { try { return Shopify.formatMoney(cents, fmt); } catch (e) {} }
    fmt = fmt || '£{{amount}}';
    function d(n, p, t, s) { var x = (n / 100).toFixed(p).split('.'); return x[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + t) + (x[1] ? s + x[1] : ''); }
    var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/), k = m ? m[1] : 'amount', v;
    if (k === 'amount_no_decimals') v = d(cents, 0, ',', '.');
    else if (k === 'amount_with_comma_separator') v = d(cents, 2, '.', ',');
    else if (k === 'amount_no_decimals_with_comma_separator') v = d(cents, 0, '.', ',');
    else v = d(cents, 2, ',', '.');
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, v);
  }
  function addToCart(items) {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return fetch(root + 'cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().then(function (d) { if (!r.ok) throw new Error(d.description || d.message || 'Could not add to cart.'); return d; });
    }).then(function (d) {
      var list = d.items || [d];
      /* Fired from the product guide wrapper so the guide's own analytics can tie the add to a guide session. It bubbles to document for the cart drawer. */
      var from = document.querySelector('.sh-v8-guide') || document;
      from.dispatchEvent(new CustomEvent('ajaxProduct:added', { bubbles: true, detail: { product: list[0], items: list } }));
      document.dispatchEvent(new CustomEvent('cart:build'));
      return list;
    });
  }

  /* Product guide (The Living Manual): its stylesheet and scripts are the same files the previous
     studio used. They load when the page is idle, or straight away when a guide control is touched. */
  var guide = null;
  function loadAsset(url, css) {
    return new Promise(function (resolve, reject) {
      if (!url) { resolve(); return; }
      var n = document.createElement(css ? 'link' : 'script');
      if (css) { n.rel = 'stylesheet'; n.href = url; } else { n.src = url; n.async = true; }
      n.onload = function () { resolve(); };
      n.onerror = function () { reject(new Error('load ' + url)); };
      document.head.appendChild(n);
    });
  }
  function loadGuide() {
    if (guide) return guide;
    var a = window.SickHausStudioAssets || {};
    window.SHProductModules = window.SHProductModules || {
      studio: function (r) { if (!r) return null; if (r.matches && r.matches('.sh-studio')) return r; return r.closest ? r.closest('.sh-studio') : null; },
      roots: function (r) { var s = this.studio(r), id = s && s.dataset && s.dataset.productId; if (!id) return s ? [s] : []; return qa(document, '.sh-studio[data-product-id="' + id + '"]'); },
      query: function (r, sel) { if (!r) return null; var l = r.querySelector ? r.querySelector(sel) : null; if (l) return l; var rs = this.roots(r); for (var i = 0; i < rs.length; i++) { if (rs[i] === r) continue; var f = rs[i].querySelector(sel); if (f) return f; } return null; },
      queryAll: function (r, sel) { if (!r) return []; var l = r.querySelectorAll ? qa(r, sel) : []; if (l.length) return l; var out = []; this.roots(r).forEach(function (m) { if (m !== r) out = out.concat(qa(m, sel)); }); return out; }
    };
    guide = Promise.all([loadAsset(a.guideCss, true), loadAsset(a.details), loadAsset(a.guide)]).catch(function (e) { guide = null; throw e; });
    return guide;
  }
  function guideReady() { return !!window.__SHLivingManualCanonicalV1; }
  function warm(e) { if (e.target && e.target.closest && e.target.closest('[data-sh-drawer-open]')) loadGuide().catch(function () {}); }
  document.addEventListener('pointerover', warm, { passive: true, capture: true });
  document.addEventListener('touchstart', warm, { passive: true, capture: true });
  document.addEventListener('focusin', warm, true);
  document.addEventListener('click', function (e) {
    var c = e.target && e.target.closest ? e.target.closest('[data-sh-drawer-open]') : null;
    if (!c || guideReady()) return;
    e.preventDefault(); e.stopPropagation();
    c.setAttribute('aria-busy', 'true');
    loadGuide().then(function () {
      c.removeAttribute('aria-busy');
      setTimeout(function () { c.click(); }, 30);
    }).catch(function () { c.removeAttribute('aria-busy'); });
  }, true);
  function idle() {
    var go = function () { loadGuide().catch(function () {}); };
    if ('requestIdleCallback' in window) requestIdleCallback(go, { timeout: 4000 }); else setTimeout(go, 2500);
  }
  if (document.readyState === 'complete') idle(); else window.addEventListener('load', idle, { once: true });

  /* full reviews: move the review app section into the V8 reviews slot. Runs first and on its own so nothing else can stop it. */
  function mountReviews(root) {
    var slot = q(root, '[data-v8-reviews-slot]');
    if (!slot) return;
    var app = q(slot, '[id$="__sh_full_reviews"]') || document.querySelector('[id^="shopify-section-"][id$="__sh_full_reviews"]') || document.querySelector('[id$="__sh_full_reviews"]');
    if (!app) return;
    if (!slot.contains(app)) slot.appendChild(app);
    root.classList.add('has-review-app');
    var fb = q(slot, '[data-v8-review-fallback]'); if (fb) fb.hidden = true;
    var wr = q(root, '[data-v8-write-review]');
    var findWrite = function () {
      return qa(app, 'button,a,[role="button"]').filter(function (b) { return !b.closest('.sh-review-priority-mirror') && /write\s+a\s+review/i.test(b.textContent || ''); })[0] || null;
    };
    if (wr) {
      var check = function () { if (findWrite()) { wr.hidden = false; return true; } return false; };
      if (!check() && 'MutationObserver' in window) {
        var mo = new MutationObserver(function () { if (check()) mo.disconnect(); });
        mo.observe(app, { childList: true, subtree: true });
        setTimeout(function () { mo.disconnect(); }, 20000);
      }
      wr.addEventListener('click', function () { var t = findWrite(); if (t) t.click(); });
    }
    /* customer photos in the aside open the review app's own photo viewer */
    qa(root, '.v8-rv__pg img').forEach(function (img, i) {
      img.addEventListener('click', function () {
        var items = qa(app, '.alr-wh-comp-photo-gallery-item');
        var it = items[Math.min(i, items.length - 1)];
        if (!it) return;
        (it.querySelector('.alr-wh-comp-review-image') || it).click();
      });
    });
  }

  function init(root) {
    if (root.__v8) return; root.__v8 = true;
    try { mountReviews(root); } catch (e) {}
    var fmt = root.getAttribute('data-money-format');
    var form = q(root, '.v8-form');
    var variants = [];
    try { variants = JSON.parse(q(root, '[data-v8-variants]').textContent); } catch (e) {}
    var idSel = q(root, '[data-v8-id]');
    var atc = q(root, '[data-v8-atc]');
    var err = q(root, '[data-v8-err]');
    var qtyIn = q(root, '[data-v8-qty-input]');
    var qtyOut = q(root, '[data-v8-qty-out]');
    var xtra = q(root, '[data-v8-xtra]');
    var plug = q(root, 'select[data-v8-opt]');
    var gw = document.querySelector('.sh-v8-guide');
    var current = null;

    function selected() {
      var out = [];
      qa(root, 'input[type=hidden][data-v8-opt]').forEach(function (i) { out[+i.dataset.v8Opt] = i.value; });
      qa(root, 'input[type=radio][data-v8-opt]:checked').forEach(function (i) { out[+i.dataset.v8Opt] = i.value; });
      if (plug) out[+plug.dataset.v8Opt] = plug.value;
      if (xtra) out[+xtra.dataset.v8Xtra] = xtra.getAttribute('aria-pressed') === 'true' ? xtra.dataset.on : xtra.dataset.off;
      return out;
    }
    function find(opts) {
      return variants.filter(function (v) { return v.options.every(function (o, i) { return opts[i] === undefined || opts[i] === o; }); })[0] || null;
    }
    function availability(opts) {
      qa(root, 'input[type=radio][data-v8-opt]').forEach(function (inp) {
        var i = +inp.dataset.v8Opt, test = opts.slice(); test[i] = inp.value;
        var v = find(test);
        inp.closest('.v8-pill').classList.toggle('is-na', !v || !v.available);
      });
      if (combo) {
        var ci = +combo.dataset.v8Opt, cur = cparts();
        qa(root, 'input[type=radio][data-v8-cpart]').forEach(function (inp) {
          var p = inp.dataset.v8Cpart, test = opts.slice();
          test[ci] = p === 'a' ? inp.value + combo.dataset.v8Combo + cur.b : cur.a + combo.dataset.v8Combo + inp.value;
          var v = find(test);
          inp.closest('.v8-pill').classList.toggle('is-na', !v || !v.available);
        });
      }
    }
    /* combined option ("Brown — 30 × 12cm", "Yellow UK plug"): two controls, one real value */
    var combo = q(root, 'input[data-v8-combo]');
    function cpartEl(p) { return q(root, 'input[type=radio][data-v8-cpart="' + p + '"]:checked') || q(root, 'select[data-v8-cpart="' + p + '"]'); }
    function cparts() { var a = cpartEl('a'), b = cpartEl('b'); return { a: a ? a.value : '', b: b ? b.value : '' }; }
    function setPart(p, val) {
      var sel = q(root, 'select[data-v8-cpart="' + p + '"]');
      if (sel) { sel.value = val; return; }
      qa(root, 'input[type=radio][data-v8-cpart="' + p + '"]').forEach(function (r) { r.checked = r.value === val; });
    }
    function partValues(p) {
      var sel = q(root, 'select[data-v8-cpart="' + p + '"]');
      if (sel) return [].map.call(sel.options, function (o) { return o.value; });
      return qa(root, 'input[type=radio][data-v8-cpart="' + p + '"]').map(function (r) { return r.value; });
    }
    function compose(changed) {
      if (!combo) return;
      var sep = combo.dataset.v8Combo, ci = +combo.dataset.v8Opt, cur = cparts();
      var opts = selected();
      var ok = function (a, b, any) { var t = opts.slice(); t[ci] = a + sep + b; var v = find(t); return v && (any || v.available) ? v : null; };
      if (!ok(cur.a, cur.b)) {
        var other = changed === 'b' ? 'a' : 'b', vals = partValues(other), done = false;
        [false, true].forEach(function (any) {
          if (done || (any && ok(cur.a, cur.b, true))) return;
          for (var k = 0; k < vals.length; k++) {
            var a = other === 'a' ? vals[k] : cur.a, b = other === 'b' ? vals[k] : cur.b;
            if (ok(a, b, any)) { setPart(other, vals[k]); cur = cparts(); done = true; break; }
          }
        });
      }
      combo.value = cur.a + sep + cur.b;
    }
    function syncGuide(v) {
      if (!gw) return;
      var gp = q(gw, '[data-sh-bar-price]'), gm = q(gw, '[data-sh-bar-meta]'), gb = q(gw, '[data-v8-guide-atc]');
      if (gp) gp.textContent = v ? money(v.price, fmt) : '';
      if (gm) gm.textContent = v ? ((v.title !== 'Default Title' ? v.title + ' · ' : '') + (v.available ? 'In stock' : 'Sold out')) : 'Unavailable';
      if (gb) gb.disabled = !v || !v.available;
    }
    function syncScale(v) {
      if (!v) return;
      var id = String(v.id);
      qa(root, '.v8-scale').forEach(function (svg) {
        var gs = svg.querySelectorAll('.v8-sz'), hit = null, i;
        for (i = 0; i < gs.length; i++) { if ((' ' + gs[i].getAttribute('data-vids') + ' ').indexOf(' ' + id + ' ') > -1) { hit = gs[i]; break; } }
        if (hit) for (i = 0; i < gs.length; i++) gs[i].classList.toggle('is-on', gs[i] === hit);
        var vc = svg.getAttribute('data-vcol');
        if (vc) vc.split(';').forEach(function (p) {
          var j = p.indexOf(':');
          if ((' ' + p.slice(j + 1) + ' ').indexOf(' ' + id + ' ') > -1) { var cc = p.slice(0, j).split('|'); svg.style.setProperty('--v8c', cc[0]); if (cc[1]) svg.style.setProperty('--v8d', cc[1]); }
        });
      });
    }
    function update(push) {
      var opts = selected(), v = find(opts);
      current = v;
      qa(root, '.v8-field--plug select').forEach(function (sel) { var o = sel.options[sel.selectedIndex], l = q(sel.closest('.v8-field--plug'), '[data-v8-plug-label]'); if (l) l.textContent = o ? o.text : ''; });
      qa(root, '[data-v8-sel]').forEach(function (b) {
        var i = +b.dataset.v8Sel, fs = b.closest('fieldset'), r = fs && q(fs, 'input[type=radio]:checked');
        if (r && r.nextElementSibling) b.textContent = r.nextElementSibling.textContent; else if (opts[i] !== undefined) b.textContent = opts[i];
      });
      if (combo) { var cp = cparts(); qa(root, '[data-v8-csel]').forEach(function (b) { b.textContent = cp[b.dataset.v8Csel] || ''; }); }
      availability(opts);
      if (xtra) {
        var on = opts.slice(), off = opts.slice(), xi = +xtra.dataset.v8Xtra;
        on[xi] = xtra.dataset.on; off[xi] = xtra.dataset.off;
        var von = find(on), voff = find(off), p = q(xtra, '[data-v8-xtra-price]');
        if (von && voff && p) { var diff = von.price - voff.price; p.textContent = diff > 0 ? '+' + money(diff, fmt).replace(/[.,]00$/, '') : ''; }
        if (von && !von.available) xtra.setAttribute('aria-disabled', 'true'); else xtra.removeAttribute('aria-disabled');
      }
      var label = q(root, '[data-v8-atc-label]'), price = q(root, '[data-v8-atc-price]');
      var stkBtn = q(root, '[data-v8-stk-add]');
      syncGuide(v);
      syncScale(v);
      if (!v) {
        atc.disabled = true; label.textContent = 'Unavailable'; if (stkBtn) stkBtn.disabled = true; return;
      }
      idSel.value = String(v.id);
      atc.disabled = !v.available; label.textContent = v.available ? 'Add to cart' : 'Sold out';
      if (stkBtn) { stkBtn.disabled = !v.available; stkBtn.textContent = v.available ? 'Add to cart' : 'Sold out'; }
      var qty = Math.max(1, +qtyIn.value || 1);
      price.textContent = money(v.price * qty, fmt);
      q(root, '[data-v8-price]').textContent = money(v.price, fmt);
      var cmp = q(root, '[data-v8-compare]');
      if (cmp) { if (v.compare_at_price > v.price) { cmp.textContent = money(v.compare_at_price, fmt); cmp.hidden = false; } else cmp.hidden = true; }
      var sp = q(root, '[data-v8-stk-price]'); if (sp) sp.textContent = money(v.price, fmt);
      var fbt = q(root, '[data-v8-fbt]');
      if (fbt) {
        fbt.dataset.mainId = v.id;
        var mp = q(fbt, '[data-v8-fbt-main-price]'); mp.dataset.price = v.price; mp.textContent = money(v.price, fmt);
        var mn = q(fbt, '[data-v8-fbt-main-note]'); if (mn) mn.textContent = v.title === 'Default Title' ? '' : v.title.split(' / ').join(', ');
        fbtTotal();
      }
      if (push && history.replaceState) {
        var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u.toString());
      }
      if (push && v.featured_media) gotoMedia(v.featured_media.id);
    }

    root.addEventListener('change', function (e) {
      if (e.target.matches('[data-v8-cpart]')) { compose(e.target.dataset.v8Cpart); err.hidden = true; update(true); }
      if (e.target.matches('[data-v8-opt]')) { err.hidden = true; update(true); }
      if (e.target.matches('[data-v8-fbt-item]')) fbtTotal();
    });
    if (xtra) xtra.addEventListener('click', function () {
      xtra.setAttribute('aria-pressed', xtra.getAttribute('aria-pressed') === 'true' ? 'false' : 'true'); update(true);
    });
    qa(root, '[data-v8-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        var n = Math.max(1, Math.min(99, (+qtyIn.value || 1) + (+b.dataset.v8Qty)));
        qtyIn.value = n; qtyOut.textContent = n; update(false);
      });
    });

    form.addEventListener('submit', function (e) {
      if (!window.fetch || !current) return;
      e.preventDefault();
      if (!current.available) return;
      atc.classList.add('is-busy'); err.hidden = true;
      addToCart([{ id: current.id, quantity: Math.max(1, +qtyIn.value || 1) }])
        .catch(function (x) { err.textContent = x.message; err.hidden = false; })
        .then(function () { atc.classList.remove('is-busy'); });
    });
    /* The guide's own "Add to bag" button presses this hidden proxy. */
    var gbtn = gw && q(gw, '[data-v8-guide-atc]');
    if (gbtn) gbtn.addEventListener('click', function () { if (form.requestSubmit) form.requestSubmit(atc); else atc.click(); });

    /* gallery: one image at a time with thumbnails; swipe on phones */
    var track = q(root, '[data-v8-track]'), slides = qa(root, '[data-v8-slide]'), thumbs = qa(root, '[data-v8-th]');
    var count = q(root, '[data-v8-count]'), count2 = q(root, '[data-v8-count2]');
    var cur = 0;
    function slideLeft(s) { return s.offsetLeft - slides[0].offsetLeft; }
    function slideIndex() {
      if (!track || !slides.length) return 0;
      var x = track.scrollLeft, best = 0, bd = 1e9;
      slides.forEach(function (s, i) { var d = Math.abs(slideLeft(s) - x); if (d < bd) { bd = d; best = i; } });
      return best;
    }
    function markSlide(i) {
      cur = i;
      var n = String(i + 1);
      if (count) count.textContent = n;
      if (count2) count2.textContent = n;
      thumbs.forEach(function (t) { var on = +t.dataset.v8Th === i; t.classList.toggle('is-on', on); if (on) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current'); });
      var on = thumbs.filter(function (t) { return +t.dataset.v8Th === i; })[0];
      if (on && on.parentNode && on.parentNode.scrollHeight > on.parentNode.clientHeight + 4) {
        var r = on.parentNode, top = on.offsetTop - r.offsetTop;
        if (top < r.scrollTop || top + on.offsetHeight > r.scrollTop + r.clientHeight) r.scrollTo({ top: Math.max(0, top - 8), behavior: 'smooth' });
      }
    }
    var warmed = false;
    function warmSlides() { if (warmed) return; warmed = true; qa(root, '[data-v8-slide] img').forEach(function (img) { img.loading = 'eager'; }); }
    function goto(i, instant) {
      if (!track || !slides.length) return;
      i = (i + slides.length) % slides.length;
      warmSlides();
      track.scrollTo({ left: slideLeft(slides[i]), behavior: instant ? 'auto' : 'smooth' });
      markSlide(i);
    }
    if (track) {
      var raf;
      track.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(function () { markSlide(slideIndex()); }); }, { passive: true });
      track.addEventListener('pointerenter', warmSlides, { once: true });
      track.addEventListener('touchstart', warmSlides, { once: true, passive: true });
      thumbs.forEach(function (t) { t.addEventListener('click', function () { goto(+t.dataset.v8Th); }); });
      qa(root, '[data-v8-step]').forEach(function (b) { b.addEventListener('click', function () { goto(cur + (+b.dataset.v8Step)); }); });
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); goto(cur + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); goto(cur - 1); }
      });
      window.addEventListener('resize', function () { goto(cur, true); railFade(); }, { passive: true });
      var rail = q(root, '.v8-rail');
      var railFade = function () {
        if (!rail) return;
        var more = rail.scrollHeight > rail.clientHeight + 4;
        rail.classList.toggle('is-more', more);
        rail.classList.toggle('is-end', more && rail.scrollTop + rail.clientHeight >= rail.scrollHeight - 4);
      };
      if (rail) { rail.addEventListener('scroll', railFade, { passive: true }); setTimeout(railFade, 60); }
    }
    function gotoMedia(id, instant) {
      var i = -1;
      slides.forEach(function (s, k) { if (s.dataset.mediaId === String(id)) i = k; });
      if (i > -1) goto(i, instant);
    }

    /* keep the desktop gallery clear of a sticky site header */
    function stickyTop() {
      var top = 0;
      qa(document, 'header, [class*="header" i], [id*="header" i]').forEach(function (el) {
        if (root.contains(el)) return;
        var cs = getComputedStyle(el);
        if (cs.position !== 'sticky' && cs.position !== 'fixed') return;
        var r = el.getBoundingClientRect();
        if (r.height > 0 && r.height < 220 && r.top <= 40) top = Math.max(top, r.height);
      });
      root.style.setProperty('--v8-top', (top + 20) + 'px');
    }
    stickyTop();
    window.addEventListener('resize', stickyTop, { passive: true });

    /* photo viewer */
    var lb = q(root, '[data-v8-lb]');
    function openLb(i) {
      if (!lb) return;
      if (lb.showModal) lb.showModal(); else lb.setAttribute('open', '');
      var it = qa(lb, '[data-v8-lb-item]')[i || 0];
      qa(lb, 'img').forEach(function (img) { img.loading = 'eager'; });
      if (it) setTimeout(function () { it.scrollIntoView({ block: 'start' }); }, 30);
      document.documentElement.style.overflow = 'hidden';
    }
    slides.forEach(function (s) { s.addEventListener('click', function () { openLb(+s.dataset.index); }); });
    qa(root, '[data-v8-open-gallery]').forEach(function (b) { b.addEventListener('click', function () { openLb(+b.getAttribute('data-v8-open-gallery')); }); });
    if (lb) {
      lb.addEventListener('click', function (e) { if (e.target === lb || e.target.closest('[data-v8-close]')) { if (lb.close) lb.close(); else lb.removeAttribute('open'); } });
      lb.addEventListener('close', function () { document.documentElement.style.overflow = ''; });
    }

    /* often bought together */
    var fbt = q(root, '[data-v8-fbt]');
    function fbtTotal() {
      if (!fbt) return;
      var main = q(fbt, '[data-v8-fbt-main-price]'), tot = +main.dataset.price, was = +main.dataset.price, n = 1;
      qa(fbt, '[data-v8-fbt-item]').forEach(function (c) { if (c.checked) { tot += +c.dataset.price; was += +c.dataset.compare; n++; } });
      q(fbt, '[data-v8-fbt-total]').textContent = money(tot, fmt);
      var w = q(fbt, '[data-v8-fbt-was]'); if (was > tot) { w.textContent = money(was, fmt); w.hidden = false; } else w.hidden = true;
      q(fbt, '[data-v8-fbt-count-label]').textContent = 'Total for ' + n;
      q(fbt, '[data-v8-fbt-add]').textContent = n > 1 ? 'Add all ' + n + ' to cart' : 'Add to cart';
    }
    if (fbt) {
      fbtTotal();
      q(fbt, '[data-v8-fbt-add]').addEventListener('click', function () {
        var btn = this, msg = q(fbt, '[data-v8-fbt-msg]'), mainId = +fbt.dataset.mainId;
        var extras = qa(fbt, '[data-v8-fbt-item]').filter(function (c) { return c.checked; }).map(function (c) { return { id: +c.value, quantity: 1 }; });
        btn.classList.add('is-busy'); msg.hidden = true;
        var root2 = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        fetch(root2 + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); }).catch(function () { return { items: [] }; })
          .then(function (cart) {
            var inCart = (cart.items || []).some(function (it) { return it.variant_id === mainId; });
            var items = inCart ? extras : [{ id: mainId, quantity: 1 }].concat(extras);
            if (!items.length) { msg.textContent = 'Already in your cart.'; msg.hidden = false; return; }
            return addToCart(items);
          })
          .catch(function (x) { msg.textContent = x.message; msg.hidden = false; })
          .then(function () { btn.classList.remove('is-busy'); });
      });
    }

    /* quick add in The rest of the room */
    qa(root, '[data-v8-quick]').forEach(function (b) {
      b.addEventListener('click', function () {
        b.classList.add('is-busy');
        addToCart([{ id: +b.dataset.v8Quick, quantity: 1 }])
          .then(function () { b.classList.add('is-done'); })
          .catch(function (x) { b.title = x.message; b.classList.add('is-err'); })
          .then(function () { b.classList.remove('is-busy'); });
      });
    });

    /* sticky add to cart on mobile */
    var stk = q(root, '[data-v8-stk]');
    if (stk && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (en) {
          var show = !en.isIntersecting && en.boundingClientRect.top < 0 && window.innerWidth < 1024;
          stk.hidden = !show;
          document.body.style.paddingBottom = show ? '76px' : '';
          document.body.classList.toggle('sh-v8-stk-on', show);
        });
      });
      io.observe(atc);
      q(stk, '[data-v8-stk-add]').addEventListener('click', function () {
        if (form.requestSubmit) form.requestSubmit(atc); else atc.click();
      });
    }

    update(false);
    if (current && current.featured_media && slides[0] && String(current.featured_media.id) !== slides[0].dataset.mediaId) {
      gotoMedia(current.featured_media.id, true);
    }
  }

  function boot() { qa(document, '[data-shv8]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
